import React from 'react';
import { 
  FaCode, 
  FaCloud, 
  FaDatabase, 
  FaBrain, 
  FaGraduationCap,
  FaPalette,
  FaMobileAlt,
  FaShieldAlt,
  FaChartLine,
  FaLaptopCode,
  FaBullhorn,
  FaBriefcase,
  FaServer,
  FaCoins,
  FaGamepad,
  FaCog
} from 'react-icons/fa';
import './Categories.css';

const Categories = () => {
  const categories = [
    {
      icon: <FaCode />,
      title: 'Developer',
      description: 'Frontend, Backend, Full-stack opportunities',
      color: '#3b82f6'
    },
    {
      icon: <FaCloud />,
      title: 'DevOps',
      description: 'Cloud infrastructure and automation',
      color: '#f59e0b'
    },
    {
      icon: <FaDatabase />,
      title: 'Data Science',
      description: 'Analytics, insights, and data engineering',
      color: '#8b5cf6'
    },
    {
      icon: <FaBrain />,
      title: 'Machine Learning',
      description: 'AI, ML engineering, and deep learning',
      color: '#10b981'
    },
    {
      icon: <FaPalette />,
      title: 'UI/UX Design',
      description: 'User interface and experience design roles',
      color: '#ef4444'
    },
    {
      icon: <FaMobileAlt />,
      title: 'Mobile Development',
      description: 'iOS, Android, and cross-platform apps',
      color: '#06b6d4'
    },
    {
      icon: <FaShieldAlt />,
      title: 'Cybersecurity',
      description: 'Security engineering and threat analysis',
      color: '#dc2626'
    },
    {
      icon: <FaChartLine />,
      title: 'Product Management',
      description: 'Product strategy and roadmap planning',
      color: '#7c3aed'
    },
    {
      icon: <FaLaptopCode />,
      title: 'QA/Testing',
      description: 'Quality assurance and test automation',
      color: '#14b8a6'
    },
    {
      icon: <FaBullhorn />,
      title: 'Sales & Marketing',
      description: 'Tech sales, digital marketing, and growth',
      color: '#f97316'
    },
    {
      icon: <FaBriefcase />,
      title: 'Business Analyst',
      description: 'Business intelligence and requirements analysis',
      color: '#6366f1'
    },
    {
      icon: <FaServer />,
      title: 'Cloud Architect',
      description: 'AWS, Azure, GCP architecture and solutions',
      color: '#0ea5e9'
    },
    {
      icon: <FaCoins />,
      title: 'Blockchain',
      description: 'Web3, DeFi, and cryptocurrency development',
      color: '#f59e0b'
    },
    {
      icon: <FaGamepad />,
      title: 'Game Development',
      description: 'Game design, Unity, Unreal Engine roles',
      color: '#ec4899'
    },
    {
      icon: <FaCog />,
      title: 'Site Reliability',
      description: 'SRE, reliability engineering, and system operations',
      color: '#a855f7'
    },
    {
      icon: <FaGraduationCap />,
      title: 'Internships',
      description: 'Perfect for students and fresh graduates',
      color: '#84cc16'
    }
  ];

  return (
    <section id="categories" className="categories">
      <div className="categories-container">
        <div className="section-header">
          <h2 className="section-title">Explore Categories</h2>
          <p className="section-description">
            Find opportunities in your field of expertise
          </p>
        </div>
        <div className="categories-grid">
          {categories.map((category, index) => (
            <div 
              key={index} 
              className="category-card"
              style={{ '--category-color': category.color }}
            >
              <div className="category-icon">{category.icon}</div>
              <h3 className="category-title">{category.title}</h3>
              <p className="category-description">{category.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Categories;

